import React from "react";
import { Route, Switch } from "react-router-dom";
import "./App.css";
import Recipes from "./pages/Recipes";
import Home from "./pages/Home";
import SingleRecipe from "./pages/SingleRecipe";
import Navbar from "./components/Navbar";

// Carousel CSS
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Videos from "./pages/Videos";
import Error from "./pages/Error";

function App() {
  return (
    <>
      <Navbar />
      <Switch>
        <Route exact path="/" component={Home} />
        <Route exact path="/recipes" component={Recipes} />
        <Route path="/recipes/:id" component={SingleRecipe} />
        <Route path="/videos" component={Videos} />
        <Route path="/featured/:name" component={SingleRecipe} />
        <Route component={Error} />
      </Switch>
    </>
  );
}

export default App;
